import './bootstrap';
import '../css/app.css';
import 'vue-final-modal/style.css';

import { createSSRApp, h } from 'vue'
import { createInertiaApp, router } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';

import { ZiggyVue } from '../../vendor/tightenco/ziggy/dist/vue.m';
import { createVfm } from 'vue-final-modal';
// import 'flowbite' убран: его JS инициализирует компоненты по data-атрибутам
// (data-modal-target и прочие), а их в разметке нет ни одного.
// CSS-плагин flowbite в tailwind.config остаётся — он даёт стили.

const vfm = createVfm();

//  обработчик ошибок гидрации
let hydrationErrorReported = false;

const reportHydrationError = (error) => {
    if (!hydrationErrorReported) {
        console.error('🚨 SSR Hydration Error:', error);
        hydrationErrorReported = true;


    }
};

createInertiaApp({
    title: (title) => `${title}`,
    progress: { color: '#4B5563', showSpinner: true },
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        const app = createSSRApp({ render: () => h(App, props) })
            .use(plugin)
            .use(vfm)
            .use(ZiggyVue, Ziggy);

        // обработчик ошибок
        app.config.errorHandler = (error, instance, info) => {
            if (error.message.includes('hydration') || info.includes('hydration')) {
                reportHydrationError({
                    error: error.message,
                    component: instance?.$options?.name,
                    info: info
                });
            }
        };

        return app.mount(el);
    },
});

// Inertia меняет URL через history.pushState — Метрика такие переходы сама не видит
// и засчитывает визиту одну-единственную страницу. Без ручного hit завышаются отказы,
// не работают URL-цели и не собирается ретаргетинг по страницам.
let ymPrevUrl = typeof window !== 'undefined' ? window.location.href : '';
// Inertia шлёт navigate и на первичной загрузке страницы, а её Метрика уже
// засчитала сама при инициализации счётчика. Первое событие пропускаем, иначе
// каждый вход на сайт (и каждый переход по обычной <a>, а не <Link>) даёт два
// просмотра вместо одного.
let ymFirstNavigate = true;
router.on('navigate', (event) => {
    if (ymFirstNavigate) { ymFirstNavigate = false; return; }
    const path = event.detail.page.url;
    try {
        if (typeof window.ym === 'function') {
            window.ym(24900584, 'hit', path, {
                title: document.title,
                referer: ymPrevUrl,
            });
        }
        ymPrevUrl = window.location.href;
    } catch (e) { /* аналитика не должна ломать переходы */ }
});
